export const ERROR_BOUNDARY_TRANSLATIONS = {
  es: {
    title: 'Algo salió mal',
    message: 'Ha ocurrido un error inesperado. Intentá recargar la página.',
    reload: 'Recargar página',
    home: 'Ir al inicio'
  },
  en: {
    title: 'Something went wrong',
    message: 'An unexpected error occurred. Try reloading the page.',
    reload: 'Reload page',
    home: 'Go to home'
  },
  it: {
    title: 'Qualcosa è andato storto',
    message: 'Si è verificato un errore imprevisto. Prova a ricaricare la pagina.',
    reload: 'Ricarica pagina',
    home: 'Vai alla home'
  },
  pt: {
    title: 'Algo deu errado',
    message: 'Ocorreu um erro inesperado. Tente recarregar a página.',
    reload: 'Recarregar página',
    home: 'Ir para o início'
  },
  fr: {
    title: 'Une erreur est survenue',
    message: 'Une erreur inattendue s\'est produite. Essayez de recharger la page.',
    reload: 'Recharger la page',
    home: 'Retour à l\'accueil'
  },
  de: {
    title: 'Etwas ist schiefgelaufen',
    message: 'Ein unerwarteter Fehler ist aufgetreten. Versuche die Seite neu zu laden.',
    reload: 'Seite neu laden',
    home: 'Zur Startseite'
  },
  gl: {
    title: 'Algo saíu mal',
    message: 'Ocorreu un erro inesperado. Tenta recargar a páxina.',
    reload: 'Recargar páxina',
    home: 'Ir ao inicio'
  },
  nap: {
    title: 'Quaccosa è gghiuta storta',
    message: 'S\'è verificato nu errore. Prova a ricaricà \'a paggena.',
    reload: 'Ricarica paggena',
    home: 'Vaje â casa'
  },
  ca: {
    title: 'Alguna cosa ha anat malament',
    message: 'S\'ha produït un error inesperat. Prova de recarregar la pàgina.',
    reload: 'Recarregar pàgina',
    home: 'Anar a l\'inici'
  },
  eu: {
    title: 'Zerbait gaizki joan da',
    message: 'Ustekabeko errore bat gertatu da. Saiatu orria birkargatzen.',
    reload: 'Orria birkargatu',
    home: 'Hasierara joan'
  }
}
